import { PILLAR_LABEL } from '../lib/labels.js';

/**
 * PostFilters — status + pillar chips + date range, shared across Dashboard,
 * ProjectDetail, and the Posts page. Controlled: parent owns the state.
 */
const STATE_FILTERS = [
  { value: '',           label: 'All' },
  { value: 'review',     label: 'In review' },
  { value: 'approved',   label: 'Approved' },
  { value: 'publishing', label: 'Publishing' },
  { value: 'published',  label: 'Published' },
  { value: 'failed',     label: 'Failed' },
  { value: 'cancelled',  label: 'Cancelled' },
];

// Pillar options come from the shared label map (single source of truth) so a
// new pillar added there shows up here automatically.
const PILLAR_FILTERS = [
  { value: '', label: 'All pillars' },
  ...Object.entries(PILLAR_LABEL).map(([value, label]) => ({ value, label })),
];

export function PostFilters({ state, pillar, from, to, onChange }) {
  const update = (patch) => onChange({ state, pillar, from, to, ...patch });
  return (
    <div className="post-filters">
      <div className="filter-row">
        {STATE_FILTERS.map((f) => (
          <button
            type="button"
            key={f.value || 'all'}
            className={`filter-chip ${state === f.value ? 'active' : ''}`}
            onClick={() => update({ state: f.value })}
          >
            {f.label}
          </button>
        ))}
      </div>
      <div className="filter-row">
        {PILLAR_FILTERS.map((f) => (
          <button
            type="button"
            key={f.value || 'all-pillars'}
            className={`filter-chip ${(pillar || '') === f.value ? 'active' : ''}`}
            onClick={() => update({ pillar: f.value })}
          >
            {f.label}
          </button>
        ))}
      </div>
      <div className="filter-dates">
        <label className="filter-date">
          <span>From</span>
          <input type="date" value={from || ''} max={to || undefined} onChange={(e) => update({ from: e.target.value })} />
        </label>
        <label className="filter-date">
          <span>To</span>
          <input type="date" value={to || ''} min={from || undefined} onChange={(e) => update({ to: e.target.value })} />
        </label>
        {(from || to) && (
          <button type="button" className="btn-compact" onClick={() => update({ from: '', to: '' })}>Clear dates</button>
        )}
      </div>
    </div>
  );
}

/** Build the /posts query string from filter state (+ optional project/limit). */
export function buildPostsQuery({ state, pillar, from, to, project, limit }) {
  const params = new URLSearchParams();
  if (limit) params.set('limit', String(limit));
  if (state) params.set('state', state);
  if (pillar) params.set('pillar', pillar);
  if (from) params.set('from', from);
  if (to) params.set('to', to);
  if (project) params.set('project', project);
  return params.toString();
}
